import { SsoAuthService } from '../ecan/sso-auth.service';
import { AppConfigurationService } from '../stp/stp-app/common';
import { UrlService } from '../shared/services/url.service';

export function jwtOptionsFactory(ssoAuthService: SsoAuthService, appConfig: AppConfigurationService, urlService: UrlService) {
  const apiUrl = appConfig.getValue('apiUrl');
  const apiHostname = urlService.getHost(apiUrl);
  return {
    tokenGetter: () => {
      return ssoAuthService.getToken();
    },
    whitelistedDomains: [apiUrl, apiHostname]
  };
}
